import Cookies from 'js-cookie';
export var COOKIE_REBUY_ATTR = 'BOM-REBUY_ATTR';
export var COOKIE_EXPIRY_DAYS = 1;
export var rebuyCookieOptions = { expires: COOKIE_EXPIRY_DAYS };
/**
 * Reads the attribution data from the cookie
 * @returns The parsed attribution data or an empty object if the cookie doesn't exist or is invalid.
 */
var getAttributionData = function () {
    var cookieValue = Cookies.get(COOKIE_REBUY_ATTR);
    if (!cookieValue) {
        return {};
    }
    try {
        return JSON.parse(cookieValue);
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing Rebuy attribution cookie:', error);
        return {};
    }
};
/**
 * Writes the attribution data to the cookie.
 */
var setAttributionData = function (data) {
    Cookies.set(COOKIE_REBUY_ATTR, JSON.stringify(data), rebuyCookieOptions);
};
/**
 * Adds a product to the list of attributable products with the specified source.
 * @param id The Product ID.
 * @param source The attribution source
 */
export var addProduct = function (id, source) {
    var data = getAttributionData();
    data[id] = source;
    setAttributionData(data);
};
/**
 * Removes a product from the list of attributable products.
 * @param id The Product ID to remove.
 */
export var removeProduct = function (id) {
    var data = getAttributionData();
    if (data[id]) {
        delete data[id];
        setAttributionData(data);
    }
};
/**
 * Determines if the provided product is included in the list of attributable products.
 * @param id The Product ID to check.
 * @returns The attribution source if the product is attributable, otherwise false.
 */
export var checkIsAttributable = function (id) {
    var data = getAttributionData();
    return data[id] || false;
};
